import { writable } from "svelte/store"

const activeAreaAbortController = writable<AbortController | undefined>();

export default activeAreaAbortController;